import { render, staticRenderFns } from "./PurchaseRequisitions.vue?vue&type=template&id=3cd60f60&scoped=true&"
import script from "./PurchaseRequisitions.vue?vue&type=script&lang=ts&"
export * from "./PurchaseRequisitions.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseRequisitions.vue?vue&type=style&index=0&id=3cd60f60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd60f60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VDatePicker,VMenu,VProgressLinear,VSelect,VTextField})
